export default __webpack_public_path__ + "b6e5b0aeee0ed570abbb67b729efcac0.png";